<template>
  <div class="gerenshenhe">
    <div class="grshenhe-time">
      <el-timeline :reverse="reverse">
        <el-timeline-item
          v-for="(activity, index) in activities"
          :key="index"
          :color="activity.color"
          :timestamp="activity.timestamp"
        >
          {{ activity.content }}
        </el-timeline-item>
      </el-timeline>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      reverse: true,
      activities: [
        {
          content: "",
          timestamp: "",
          color:'#0bbd87'
        },
        {
          content: "",
          timestamp: "",
          color:'#0265BB'
        },
        {
          content: "",
          timestamp: "",
          color:'red'
          
        },
      ],
    }
  },
  mounted(){
    let status = JSON.parse(sessionStorage.getItem("status"));
    // console.log(status,'状态')
    if (status == 0 && JSON.parse(localStorage.getItem("grxinxi")).is_teacher == 1) {
      this.activities[1].content = '审核中';

    }else if (status == 1 && JSON.parse(localStorage.getItem("grxinxi")).is_teacher == 1) {
      this.activities[0].content = '审核通过';
    }else if (status == -1 && JSON.parse(localStorage.getItem("grxinxi")).is_teacher == 1) {
       this.activities[2].content = '审核未通过';
    }
  }
   
};
</script>

<style>
.gerenshenhe {
  width: 1269px;
  height: 700px;
  background: #ffffff;
  border-radius: 5px;
  float: right;
  margin-top: 30px;
}
.grshenhe-time{
    width: 400px;
    margin: 30px 0 0 30px;
}
.grshenhe-time .el-timeline-item__content{
    font-size: 18px;
    height: 80px;
}
</style>


// WEBPACK FOOTER //
// src/components/GeRenshenhe.vue